import { Modal, Button } from "react-bootstrap";

const TermsModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Flavchap.com - Terms & Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Last Updated: </strong>{process.env.REACT_APP_TERMS_UPDATE_DATE}</p>
        <h5>Hello User!</h5>
        <p>
          Welcome to <strong>flavchap.com</strong> (“flavchap”, “we”, “our”, “us”). These Terms and Conditions (“Terms”) govern your access to and use of our website, products, and services. By accessing or using our platform, you agree to comply with and be bound by these Terms. Please read them carefully.
        </p>

        <h6>1. Overview</h6>
        <p>
          Flavchap.com is an online food retail and delivery service offering a curated range of traditional Indian snacks, sweets, and related food items. Our goal is to deliver high-quality products to our customers with reliability and transparency.
        </p>

        <h6>2. Eligibility</h6>
        <p>
          By using this website, you confirm that:
          <ul>
            <li>
              You are at least 18 years old, or using the website under the supervision of a parent or guardian.
            </li>
            <li>
              You are capable of entering into a legally binding agreement under applicable law.
            </li>
          </ul>
        </p>

        <h6>3. Account Registration</h6>
        <p>
          <ul>
            <li>
              You may be required to create an account to place orders or access certain features.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </li>
            <li>
              Flavchap reserves the right to suspend or terminate your account if any information provided is found to be inaccurate, misleading, or fraudulent.
            </li>
          </ul>
        </p>

        <h6>4. Products and Availability</h6>
        <p>
          <ul>
            <li>
              All products listed on flavchap.com are subject to availability.
            </li>
            <li>
              We reserve the right to discontinue or modify any product without prior notice.
            </li>
            <li>
              Product images are for illustrative purposes only. Actual product appearance may vary due to packaging or manufacturing differences.
            </li>
          </ul>
        </p>

        <h6>5. Pricing and Payments</h6>
        <p>
          <ul>
            <li>
              All prices are listed in Indian Rupees (INR) and are NOT inclusive of applicable taxes unless stated otherwise.
            </li>
            <li>
              We reserve the right to modify prices at any time without prior notice.
            </li>
            <li>
              Payments can be made via the available online payment service providers and/or gateways (e.g., RazorPay, UPI, credit/debit cards, wallets, or net banking).
            </li>
            <li>
              You agree to provide valid payment information and authorize us to process the payment for your order.
            </li>
          </ul>
        </p>

        <h6>6. Orders and Delivery</h6>
        <p>
          <ul>
            <li>
              Once an order is placed, you will receive a confirmation via email, SMS, or WhatsApp.
            </li>
            <li>
              Delivery timelines are estimated and may vary due to factors beyond our control (e.g., weather, logistics, regional holidays).
            </li>
            <li>
              In case of delivery failure due to an incorrect address or unavailability of the customer, redelivery charges may apply.
            </li>
            <li>
              Flavchap currently delivers to selected locations. Delivery availability is determined based on your pincode.
            </li>
          </ul>
        </p>

        <h6>7. Returns, Replacements, and Refunds</h6>
        <p>
          <ul>
            <li>
              Due to the perishable nature of food products, we do not accept returns once the order is delivered. You are required to check the order prior to accepting it from the delivery personnel.
            </li>
            <li>
              If you receive a damaged package, do not accept the delivery and please contact our support team with order details within 6 hours of attempted delivery.
            </li>
            <li>
              If you find a damaged, incorrect, or spoiled item up on accepting and opening the package, please contact our support team with order details within 2 hours of receiving the order.
            </li>
            <li>
              Refunds or replacements are processed only after verification and at our sole discretion.
            </li>
            <li>
              Refunds, if approved, will be credited to the original payment method within 7–10 business days.
            </li>
          </ul>
        </p>

        <h6>8. Cancellation Policy</h6>
        <p>
          <ul>
            <li>
              Orders once placed cannot be cancelled under any circumstances.
            </li>
          </ul>
        </p>

        <h6>9. Use of Website</h6>
        <p>
          You agree not to:
          <ul>
            <li>
              Use the website for unlawful purposes or to violate any applicable laws.
            </li>
            <li>
              Copy, modify, distribute, or exploit any part of the website or its content without prior written consent.
            </li>
            <li>
              Attempt to interfere with the website’s operation, security, or underlying systems.
            </li>
          </ul>
        </p>

        <h6>10. Intellectual Property</h6>
        <p>
          All content, including logos, text, images, graphics, product descriptions, and trademarks displayed on flavchap.com, are the intellectual property of Flavchap or its content suppliers Unauthorized use of any material is strictly prohibited.
        </p>

        <h6>11. Communications</h6>
        <p>
          By using our website, you consent to receive communications from us via email, SMS, or WhatsApp regarding orders, offers, and updates. You can opt out of promotional messages at any time.
        </p>

        <h6>12. Limitation of Liability</h6>
        <p>
          <ul>
            <li>
              Flavchap shall not be held liable for any indirect, incidental, or consequential damages arising out of the use or inability to use our products or services.
            </li>
            <li>
              We are not responsible for delays or failures due to events beyond our reasonable control, including natural disasters, strikes, or transportation issues.
            </li>
          </ul>
        </p>

        <h6>13. Indemnification</h6>
        <p>
          You agree to indemnify and hold harmless Flavchap, its affiliates, employees, and agents from any claims, damages, or expenses arising from your use of the website or breach of these Terms.
        </p>

        <h6>14. Privacy Policy</h6>
        <p>
          Your personal data is collected, processed, and protected in accordance with our Privacy Policy, which you can refer to in the footer section of the website.
        </p>

        <h6>15. Governing Law and Jurisdiction</h6>
        <p>
          These Terms are governed by and construed in accordance with the laws of India.
          <br/>Any disputes shall be subject to the exclusive jurisdiction of the courts of Hyderabad, Telangana.
        </p>

        <h6>16. Modifications</h6>
        <p>
          Flavchap reserves the right to update or modify these Terms at any time without prior notice. <br/>Continued use of the website after any changes implies your acceptance of the updated Terms.
        </p>

        <h6>17. Contact Us</h6>
        <p>
          For any queries, feedback, or complaints, you can reach us at:
          <br/>📧 info@ncgglobalenterprises.com
          <br/>🌐 www.flavchap.com
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;